import { netGet, netPost,netUpload } from "@/utils/NetHelper";


//用户登录
export const bllLogin = async (jsonObj) => {

  let res = await netPost('User/Login', jsonObj); //User/Login
  console.log(res);
  if (res.Code == 0) {
    localStorage.setItem("UserName", res.JsonData.UserName); //永久本地保存
    localStorage.setItem("Pwd", res.JsonData.Pwd); //永久本地保存
    sessionStorage.setItem("Token", res.JsonData.Token);//临时保存TOKEN
    sessionStorage.setItem("Refresh_token", res.JsonData.Refresh_token);//临时保存Refresh_token
    bllGetUserInfo(res.JsonData.Token);
  }
  return res;
}

//取得用户信息
export const bllGetUserInfo = async (token) => {
  let jsonObj = {
    Token: token
  }
  let res = await netPost('User/GetUserInfo', jsonObj);
  if (res.Code == 0) {
    localStorage.setItem("UserId", res.JsonData.UserId); //永久本地保存
    localStorage.setItem("NickName", res.JsonData.UserName); //永久本地保存
  }
  return res;
}

//绑定微信openid
export const bllWxAppBind = async (Flag, WxOpenId) => {
  let jsonObj = {
    WxOpenId: WxOpenId,
    Flag: Flag //Flag：0查看，1绑定，2解绑
  }
  let res = await netPost('User/WxAppBind', jsonObj);
  return res;
}

//取得设备列表
export const bllGetDeviceList = async (keystr, pageIndex, pageSize) => {
  if (!keystr) {
    keystr = '';
  }
  let jsonObj = {
    PageIndex: pageIndex,
    PageSize: pageSize,
    Keystr: keystr
  }
  console.log('bllGetDeviceList:');
  console.log(jsonObj);
  let res = await netPost('User/GetDeviceList', jsonObj);
  return res;
}

//取得设备信息
export const bllGetDeviceInfo = async (devId) => {
  let jsonObj = {
    DevId: devId
  }
  let res = await netPost('User/GetDeviceInfo', jsonObj);
  return res;
}

//取得点检任务列表
export const bllGetCheckList = async (keyStr, pageIndex, pageSize) => {
  if (!keyStr) {
    keyStr = '';
  }
  let jsonObj = {
    PageIndex: pageIndex,
    PageSize: pageSize,
    Keystr: keyStr
  }
  let res = await netPost('User/GetCheckList', jsonObj);
  return res;
}

//取得保养任务列表
export const bllGetMaintenanceList = async (keyStr, pageIndex, pageSize) => {
  if (!keyStr) {
    keyStr = '';
  }
  let jsonObj = {
    PageIndex: pageIndex,
    PageSize: pageSize,
    Keystr: keyStr
  }
  let res = await netPost('User/GetMaintenanceList', jsonObj);
  return res;
}

//取得维修任务列表
export const bllGetRepairList = async (pageIndex, pageSize) => {
  let jsonObj = {
    PageIndex: pageIndex,
    PageSize: pageSize
  }
  let res = await netPost('User/GetRepairList', jsonObj);
  return res;
}

//取得故障列表
export const bllGetFaultList = async (userId,pageIndex, pageSize) => {
  let jsonObj = {
    PageIndex: pageIndex,
    PageSize: pageSize,
    UserId:userId
  }
  let res = await netPost('User/GetFaultList', jsonObj);
  return res;
}

//故障上报
export const bllPostFault = async (devId, txt1, imgBase64) => {
  let jsonObj = {
    DevId: devId,
    Txt1: txt1,
    ImgBase64: imgBase64
  }
  let res = await netPost('User/PostFault', jsonObj);
  return res;
}

//指派维修
export const bllDeviceDispatch = async (devId, repairTaskID,userId) => {
  let jsonObj = {
    DevId: devId,
    RepairTaskID: repairTaskID,
    UserId:userId
  }
  let res = await netPost('User/DeviceDispatch', jsonObj);
  return res;
}

//设置维修
export const bllStartRepair = async (devId, repairTaskID) => {
  let jsonObj = {
    DevId: devId,
    RepairTaskID: repairTaskID
  }
  let res = await netPost('User/StartRepair', jsonObj);
  return res;
}

//开始维修
export const bllGetRepairTaskItem = async (repairTaskID) => {
  let jsonObj = {
    RepairTaskID: repairTaskID
  }
  let res = await netPost('User/GetRepairTaskItem', jsonObj);
  return res;
}
//取得工作中心列表数据
export const bllGetWorkCenter = async () => {
  let jsonObj = {
    key:'GetWorkCenter'
  }
  let res = await netPost('User/GetWorkCenter', jsonObj);
  return res;
}

//取得部门列表数据
export const bllGetWorkDepartment = async (key1) => {
  //Selector_Department_xz Selector_Department
  let jsonObj = {
    Key:key1
  }
  let res = await netPost('User/GetWorkDepartment', jsonObj);
  return res;
}

//取得人员列表
export const bllGetEmpList = async (centerID, DepID,scanInput) => {
  if (!scanInput) {
    scanInput = '';
  }
  let jsonObj = {
    CenterID: centerID,
    DepID:DepID,
    ScanInput: scanInput
  }
  let res = await netPost('User/GetEmpList', jsonObj);
  return res;
}
//取得维修项目列表
export const bllGetRepairItemList = async (centerID, scanInput) => {
  if (!scanInput) {
    scanInput = '';
  }
  let jsonObj = {
    CenterID: centerID,
    ScanInput: scanInput
  }
  let res = await netPost('User/GetRepairItemList', jsonObj);
  return res;
}
//取得保养项目列表
export const bllGetProjectList = async (centerID, scanInput) => {
  if (!scanInput) {
    scanInput = '';
  }
  let jsonObj = {
    CenterID: centerID,
    ScanInput: scanInput
  }
  let res = await netPost('User/GetProjectList', jsonObj);
  return res;
}

//取得保养项目列表
export const bllGetProjectItemList = async (projectID, scanInput) => {
  if (!scanInput) {
    scanInput = '';
  }
  let jsonObj = {
    ProjectID: projectID,
    ScanInput: scanInput
  }
  let res = await netPost('User/GetProjectItemList', jsonObj);
  return res;
}

//取得日常工作任务列表
export const bllGetDayWorkTaskList = async (DoState, DoManId, SheetID, pageIndex, pageSize) => {
  let jsonObj = {
    DoState: DoState,
    DoManId: DoManId,
    SheetID: SheetID,
    PageIndex: pageIndex,
    PageSize: pageSize
  }
  console.log(jsonObj);
  let res = await netPost('User/GetDayWorkTaskList', jsonObj);
  return res;
}


//取得点检方案
export const bllGetSpotCheckProjectList = async (deviceID, scanInput) => {
  if (!scanInput) {
    scanInput = '';
  }
  let jsonObj = {
    CenterID: deviceID, //设备ID
    ScanInput: scanInput
  }
  let res = await netPost('User/GetSpotCheckProjectList', jsonObj);
  return res;
}

//取得点检方案下的详细数据
export const bllGetSpotCheckProjectItemList = async (projectID) => {

  let jsonObj = {
    ProjectID: projectID
  }
  let res = await netPost('User/GetSpotCheckProjectItemList', jsonObj);
  return res;
}

//取得停机原因
export const bllGetStopReason = async (devId, scanInput) => {
  if (!scanInput) {
    scanInput = '';
  }
  let jsonObj = {
    DevId: devId,
    ScanInput: scanInput
  }
  let res = await netPost('User/GetStopReason', jsonObj);
  return res;
}

//提交维修记录
export const bllUpdateSheet = async (jsonObj) => {
  let res = await netPost('User/UpdateSheet', jsonObj);
  return res;
}

//提交保养记录
export const bllUpdateMaintaintSheet = async (jsonObj) => {
  let res = await netPost('User/UpdateMaintaintSheet', jsonObj);
  return res;
}

//提交点检记录
export const bllUpdateDeviceSpotCheckSheet = async (jsonObj) => {
  let res = await netPost('User/UpdateDeviceSpotCheckSheet', jsonObj);
  return res;
}

//新增工作任务
export const bllUpdateDayWorkTaskSheet = async (jsonObj) => {
  let res = await netPost('User/UpdateDayWorkTaskSheet', jsonObj);
  return res;
}

//指派工作任务
export const bllDispatchDayWorkTaskSheet = async (keyId,doManId,XzWorkID) => {
  let jsonObj = {
    KeyId: keyId,
    DoManId: doManId,
    XzWorkID:XzWorkID
  }
 
  let res = await netPost('User/DispatchDayWorkTaskSheet', jsonObj);
  return res;
}

//响应工作任务
export const bllStartDayWorkTaskSheet = async (keyId) => {
  let jsonObj = {
    KeyId: keyId
  }
  let res = await netPost('User/StartDayWorkTaskSheet', jsonObj);
  return res;
}
//取消工作任务
export const bllCancelDayWorkTaskSheet = async (keyId,userId) => {
  let jsonObj = {
    KeyId: keyId,
    UserId:userId
  }
  let res = await netPost('User/CancelDayWorkTaskSheet', jsonObj);
  return res;
}
//退回工作任务
export const bllReturnDayWorkTaskSheet = async (keyId,Remark) => {
  let jsonObj = {
    KeyId: keyId,
    Remark:Remark
  }
  let res = await netPost('User/ReturnDayWorkTaskSheet', jsonObj);
  return res;
}
//设置完成，未完成
export const bllSetDoDoStateDayWorkTaskSheet = async (keyId,status) => {
  let jsonObj = {
    KeyId: keyId,
    Status:status
  }
  let res = await netPost('User/SetDoDoStateDayWorkTaskSheet', jsonObj);
  return res;
}

//完成工作任务
export const bllCompleteDayWorkTaskSheet = async (keyId,doRemark,Picservice1,Picservice2,DoState) => {
  let jsonObj = {
    KeyId: keyId,
    DoRemark: doRemark,
    Picservice1:Picservice1,
    Picservice2:Picservice2,
    DoState:DoState
  }
  console.log('完成工作任务');
  console.log(jsonObj);
  
  let res = await netPost('User/CompleteDayWorkTaskSheet', jsonObj);
  return res;
}

//编辑工作任务
export const bllModDayWorkTaskSheet = async (keyId,WorkID,Remark,DoManId,PicAbnormal1,PicAbnormal2) => {
  //int keyId, int WorkID, string Remark, int DoManId,string PicAbnormal1, string PicAbnormal2
  let jsonObj = {
    KeyId: keyId,
    WorkID:WorkID,
    DoManId:DoManId,
    Remark: Remark,
    PicAbnormal1:PicAbnormal1,
    PicAbnormal2:PicAbnormal2
  }
  console.log('完成工作任务');
  console.log(jsonObj);
  
  let res = await netPost('User/ModDayWorkTaskSheet', jsonObj);
  return res;
}

//提交设备停机
export const bllDoSetStop = async (devId, StopReasonID, StopReason, Remark) => {
  let jsonObj = {
    DevId: devId,
    StopReasonID: StopReasonID,
    StopReason: StopReason,
    Remark: Remark
  }
  let res = await netPost('User/DoSetStop', jsonObj);
  return res;
}

//RFID查询
export const bllDoScan = async (keystr) => {
  let jsonObj = {
    Keystr: keystr
  }
  let res = await netPost('User/DoScan', jsonObj);
  return res;
}

//上传base64图片
export const bllUpPhotoBase64 = async (jsonObj) => {
  console.log(jsonObj);
  let res = await netPost('User/UpPhotoBase64', jsonObj);
  return res;
}

//上传base64图片
export const bllUpPhoto = async (formData) => {
  //console.log(formData);
  let res = await netUpload('http://mes.cyc.cn:9981/api/documentfile/UploadPhysical', formData);
  return res;
}